import { FC, useEffect, useRef, useState } from "react"
import { useTranslation } from "react-i18next"
import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
} from "@mui/material"
import { useAppSelector, useAppDispatch } from "@/core/app/hooks"
import { RootState } from "@/core/app/store"
import FormControlLabel from "@mui/material/FormControlLabel"
import Checkbox from "@mui/material/Checkbox"
import Radio from "@mui/material/Radio"
import RadioGroup from "@mui/material/RadioGroup"
import FormControl from "@mui/material/FormControl"
import FormLabel from "@mui/material/FormLabel"
import { ULoading, UTextField } from "@/components/index"
import { UButton } from "@/components/index"
import { useParams } from "react-router-dom"
import { getLabelResult } from "./utils"
import { wasmModule } from "@/gluelayer"
import { setOpenLabelPreview } from "@/UDTreat/udTreatSlice"
import {
  EPrintModel,
  IPrintSettingJsonObj,
} from "@/core/app/slices/user/user.type"
import { set } from "react-hook-form"
export const OrderLabel: FC<{
  exportModel: EPrintModel
  jsonData: IPrintSettingJsonObj
  updateJsonData: (data: IPrintSettingJsonObj) => void
}> = ({ exportModel, jsonData, updateJsonData }) => {
  const { openLabelPreview } = useAppSelector(
    (state: RootState) => state.udTreatService,
  )
  const { CaseTag } = jsonData
  const {
    patientData: { firstName = "", lastName = "" },
  } = useAppSelector((state: RootState) => {
    return state.patientService
  })
  const { caseId } = useParams()
  const dispatch = useAppDispatch()
  // checkbox if No label
  const [checkNoLabel, setCheckNoLabel] = useState<string>("0")

  const [showLableWarning, setShowLableWarning] = useState(false)

  const handleCheck = (event: React.ChangeEvent<HTMLInputElement>) => {
    if (exportModel === EPrintModel.LuxcreoModel) {
      return
    }
    console.log("checkNoLabel:::", (event.target as HTMLInputElement).value)
    setCheckNoLabel((event.target as HTMLInputElement).value)
    updateJsonData({
      IncludeLabelModel:
        (event.target as HTMLInputElement).value === "1"
          ? "NoCaseNumber"
          : "YesCaseNumber",
    })
  }
  // // select position
  // const [toothPosition, setToothPosition] = useState<string>("") // Bottom /WallLingual/ Wall
  const handleToothPosition = (event: React.ChangeEvent<HTMLInputElement>) => {
    updateJsonData({
      SelectPositionLabel: (event.target as HTMLInputElement).value,
    })
  }
  // custom value
  const [customVal, setCustomVal] = useState<string>("")

  const [isloading, setIsloading] = useState(false)

  const [labelPosition, setLabelPosition] = useState<string>("") // Bottom /WallLingual/ Wall
  // init tabs value
  useEffect(() => {
    if (!jsonData || Object.keys(jsonData).length === 0) return

    if (jsonData.IncludeLabelModel === "NoCaseNumber") {
      setCheckNoLabel("1")
    } else {
      setCheckNoLabel("0")
    }
    if (jsonData.SelectPositionLabel) {
      setLabelPosition(jsonData.SelectPositionLabel)
    }
  }, [jsonData])
  useEffect(() => {
    if (exportModel === EPrintModel.LuxcreoModel) {
      setCheckNoLabel("1")
    }
  }, [exportModel])
  // label text to wasm
  const setLabelFunc = () => {
    if (!CaseTag) {
      return
    }
    const labelResult = getLabelResult(CaseTag, caseId, firstName, lastName)
    const printMoudle = wasmModule.moduleManager.GetModulePrintSelection()
    if (printMoudle) {
      printMoudle.SetLabelText && printMoudle.SetLabelText(labelResult)
    }
  }
  useEffect(() => {
    try {
      const printMoudle = wasmModule.moduleManager.GetModulePrintSelection()
      if (+checkNoLabel) {
        if (printMoudle) {
          printMoudle.SetLabelText && printMoudle.SetLabelText("")
        }
      } else {
        if (customVal === "") {
          setLabelFunc()
        } else {
          printMoudle.SetLabelText && printMoudle.SetLabelText(customVal)
        }
      }
    } catch (error) {
      console.error(error)
    }
  }, [
    checkNoLabel,
    customVal,
    CaseTag,
    wasmModule.moduleManager.GetModulePrintSelection(),
  ])

  // label position to wasm
  useEffect(() => {
    try {
      const printMoudle = wasmModule.moduleManager.GetModulePrintSelection()
      if (+checkNoLabel) {
        if (printMoudle && printMoudle.SetLabelPosition) {
          const data = ""
          printMoudle.SetLabelPosition(data)
        }
      } else {
        if (printMoudle && labelPosition !== "") {
          printMoudle.SetLabelPosition &&
            printMoudle.SetLabelPosition(labelPosition)
        }
      }
    } catch (error) {
      console.error(error)
    }
  }, [labelPosition, checkNoLabel])
  useEffect(() => {
    if (labelPosition === "Bottom") {
      // setHollowModel(0)
      updateJsonData({
        GenerateShell: 0,
      })
    }
  }, [labelPosition])
  // click label preview
  const clickLabelPreview = () => {
    const printMoudle = wasmModule.moduleManager.GetModulePrintSelection()
    if (!openLabelPreview) {
      if (printMoudle && printMoudle.OnLabelPreviewButtonDown) {
        setIsloading(true)
        printMoudle.OnLabelPreviewButtonDown("labelPreviewCallBack()")
      }
    } else {
      printMoudle.ApplyInPreview()
      printMoudle.GoToOrigin3DScene()
      dispatch(setOpenLabelPreview(false))
    }
  }
  const labelPreviewCallBack = () => {
    dispatch(setOpenLabelPreview(true))
    setIsloading(false)
  }
  // Register the callback function on the window object.
  useEffect(() => {
    if (typeof window !== "undefined") {
      window.labelPreviewCallBack = labelPreviewCallBack
    }
    return () => {
      delete window.labelPreviewCallBack
    }
  }, [labelPreviewCallBack])
  return (
    <Box sx={{ width: "100%" }}>
      {/* <FormControlLabel
        control={<Checkbox checked={checkNoLabel} onChange={handleCheck} />}
        label="No label on the model"
        sx={{ margin: "0 0 10px 0" }}
      /> */}
      <FormControl sx={{ marginBottom: "24px" }}>
        <FormLabel id="labelModel">{`Include label on model`}</FormLabel>
        <RadioGroup
          row
          sx={{ marginLeft: "10px", gap: "40px" }}
          aria-labelledby="labelModel"
          name="radio-buttons-group"
          value={checkNoLabel}
          onChange={handleCheck}
        >
          <FormControlLabel value={"0"} control={<Radio />} label="Yes" />
          <FormControlLabel value={"1"} control={<Radio />} label="No" />
        </RadioGroup>
      </FormControl>
      <Box sx={{ width: "100%", display: "flex", marginBottom: "24px" }}>
        <Box sx={{ marginRight: "10px", width: "calc(50% - 5px)" }}>
          <FormControl disabled={Number.parseInt(checkNoLabel) > 0}>
            <FormLabel id="toothPosition">{`Select the position to place label`}</FormLabel>
            <RadioGroup
              sx={{ marginLeft: "10px" }}
              aria-labelledby="toothPosition"
              name="radio-buttons-group"
              value={labelPosition}
              onChange={handleToothPosition}
            >
              <FormControlLabel
                value="Bottom"
                control={<Radio />}
                label="Bottom"
              />
              <FormControlLabel
                value="WallLingual"
                control={<Radio />}
                label="Lingual wall"
              />
              <FormControlLabel
                value="Wall"
                control={<Radio />}
                label="Buccal wall"
              />
            </RadioGroup>
          </FormControl>
        </Box>
        <FormControl
          sx={{ width: "calc(50% - 5px)" }}
          disabled={Number.parseInt(checkNoLabel) > 0}
        >
          <FormLabel id="sideNumber">{` Custom label(up to 10 characters)`}</FormLabel>
          <Box sx={{ display: "flex", alignItems: "center" }}>
            <UTextField
              value={customVal}
              sxProp={{
                width: "100%",
                "& .MuiInputBase-input": {
                  height: "40px",
                  padding: "0 16px",
                },
              }}
              disabled={Number.parseInt(checkNoLabel) > 0}
              onInputchange={(val) => {
                // 检测非法字符
                const illegalChar = /[^a-zA-Z0-9-]/.test(val)

                if (illegalChar) {
                  setShowLableWarning(true)
                  return
                }

                // 只保留合法字符
                const filtered = val.replace(/[^a-zA-Z0-9-]/g, "")

                if (filtered.length <= 10) {
                  setCustomVal(filtered)
                }
              }}
            />
            {/* <UButton
              sxProp={{
                marginLeft: "10px",
                color: "#212121",
                height: "36px",
                borderRadius: "4px",
                background: "#DADCDD !important",
                boxShadow:
                  "0px 1px 5px 0px rgba(0, 0, 0, 0.12), 0px 2px 2px 0px rgba(0, 0, 0, 0.14), 0px 3px 1px -2px rgba(0, 0, 0, 0.20)",
                padding: "6px 16px",
              }}
              variant={"contained"}
              btnText={`APPLY`}
              disabled={+checkNoLabel}
              onClickHandler={clickApply}
            /> */}
          </Box>
        </FormControl>
      </Box>
      <Box sx={{ display: "flex", justifyContent: "start" }}>
        <UButton
          sxProp={{
            // marginTop: "80px",
            color: "#212121",
            height: "36px",
            width: "138px",
            borderRadius: "4px",
            background: "#DADCDD !important",
            boxShadow:
              "0px 1px 5px 0px rgba(0, 0, 0, 0.12), 0px 2px 2px 0px rgba(0, 0, 0, 0.14), 0px 3px 1px -2px rgba(0, 0, 0, 0.20)",
            padding: "6px 16px",
          }}
          variant={"contained"}
          btnText={`Label Preview`}
          disabled={
            Number.parseInt(checkNoLabel) > 0 || labelPosition === "Bottom"
          }
          onClickHandler={clickLabelPreview}
        />
      </Box>
      <ULoading isLoading={isloading} />
      <Dialog
        open={showLableWarning}
        // onClose={handleClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogContent>
          <DialogContentText
            id="alert-dialog-description"
            sx={{ color: "black" }}
          >
            Only numbers, letters and '-' are allowed for label!
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button
            sx={{
              color: "black",
              backgroundColor: "rgb(224,224,224)",
            }}
            onClick={() => {
              setShowLableWarning(false)
            }}
          >
            OK
          </Button>
          {/* <Button
            sx={{
              color: "black",
              backgroundColor: "rgb(224,224,224)",
            }}
            onClick={() => {
              setShowWarning(false)
            }}
          >
            Cancel
          </Button> */}
        </DialogActions>
      </Dialog>
    </Box>
  )
}
